const Divider = ({className="", length=12, thickness=1, variant="secondary"}) => {


    return (
        <div className={"border p-0 col-"+length+" border-"+variant+" border-"+thickness+' '+className}></div>
    );
}


export default Divider;